import { RootState } from '@/store/types';
import {
  DecodedSSN,
  FeedbackStatistics,
  IssuePaymentData,
  OrderPayment,
  OrderPaymentState,
  OrderHistory,
  IssuePaymentSMSData,
  DailyStatistics,
  FeedbackReport
} from './types';
import { ActionTree } from 'vuex';
import {
  getConfirmContent,
  getFeedbackStatistics,
  getIssuePaymentPush,
  getOrderCreate,
  getViewOrderById,
  getOrdersHistory,
  getOrdersHistoryDecodedSSN,
  resendPaymentNotification,
  getFeedbackStatisticsWeek,
  cancelPaymentRequest,
  addComment,
  getIssuePaymentSMSPush,
  getOrderPaymentData,
  getFeedbackReport,
  getCustomersSatisfaction
} from '@/services/axiosService';
import { OrderPaymentMutations } from './mutations';
import { AxiosError } from 'axios';

const cleanLocalStorage = () => {
  localStorage.removeItem('users');
};

export const actions: ActionTree<OrderPaymentState, RootState> = {
  async getIssuePaymentPush({ commit }, phoneNumber) {
    try {
      const orderPushNotification: IssuePaymentData | undefined =
        await getIssuePaymentPush(phoneNumber);

      commit(OrderPaymentMutations.get_order_push_notification, {
        orderPushNotification
      });
    } catch (error: unknown) {
      cleanLocalStorage();
    }
  },
  async getIssuePaymentSMSPush({ commit }, phoneNumber) {
    try {
      const orderSMSPushNotification: IssuePaymentSMSData | undefined =
        await getIssuePaymentSMSPush(phoneNumber);

      commit(OrderPaymentMutations.get_order_sms_push_notification, {
        orderSMSPushNotification
      });
    } catch (error: unknown) {
      cleanLocalStorage();
    }
  },
  async getOrderCreate({ commit }, data) {
    try {
      const orderPayment: OrderPayment | undefined = await getOrderCreate(data);

      commit(OrderPaymentMutations.get_order_create, {
        orderPayment
      });
    } catch (error: unknown) {
      cleanLocalStorage();
    }
  },
  async getOrderPaymentData({ commit }, { pharmacyId, orderId }) {
    try {
      const orderSMSCreate: OrderPayment | undefined =
        await getOrderPaymentData(pharmacyId, orderId);

      commit(OrderPaymentMutations.get_order_sms_create, { orderSMSCreate });
    } catch (error: unknown) {
      const axiosError = error as AxiosError;
      commit(OrderPaymentMutations.login_error, axiosError.message);
      cleanLocalStorage();
    }
  },
  async getFeedbackStatistics(
    { commit },
    { pharmacyId, startTime, endTime, minutesInterval, chartFields }
  ) {
    try {
      const feedbackStatistics: FeedbackStatistics | undefined =
        await getFeedbackStatistics(
          pharmacyId,
          startTime,
          endTime,
          minutesInterval,
          chartFields
        );

      commit(OrderPaymentMutations.get_feedback_statistics, {
        feedbackStatistics
      });
    } catch (error: unknown) {
      cleanLocalStorage();
    }
  },
  async getFeedbackStatisticsWeek(
    { commit },
    { pharmacyId, startTime, endTime, minutesInterval, chartFields }
  ) {
    try {
      const feedbackStatisticsWeek: FeedbackStatistics | undefined =
        await getFeedbackStatisticsWeek(
          pharmacyId,
          startTime,
          endTime,
          minutesInterval,
          chartFields
        );

      commit(OrderPaymentMutations.get_feedback_statistics_week, {
        feedbackStatisticsWeek
      });
    } catch (error: unknown) {
      cleanLocalStorage();
    }
  },
  async getCustomersSatisfaction(
    { commit },
    { pharmacyId, startTime, endTime, otherPeriod }
  ) {
    try {
      const dailyStatistics: DailyStatistics | undefined =
        await getCustomersSatisfaction(
          pharmacyId,
          startTime,
          endTime,
          otherPeriod
        );

      commit(OrderPaymentMutations.get_daily_statistics, {
        dailyStatistics
      });
    } catch (error: unknown) {
      cleanLocalStorage();
    }
  },
  async getFeedbackReport({ commit }, { pharmacyId, startTime, endTime }) {
    try {
      const feedbackReport: FeedbackReport | undefined =
        await getFeedbackReport(pharmacyId, startTime, endTime);
      console.log('feedbackReport', feedbackReport);

      commit(OrderPaymentMutations.get_feedback_report, {
        feedbackReport
      });
    } catch (error: unknown) {
      cleanLocalStorage();
    }
  },
  async getOrdersHistory({ commit }, { pharmacyId, startTime, endTime }) {
    try {
      const ordersHistory: OrderHistory[] | undefined = await getOrdersHistory(
        pharmacyId,
        startTime,
        endTime
      );

      commit(OrderPaymentMutations.get_payments_history, {
        ordersHistory
      });
    } catch (error: unknown) {
      cleanLocalStorage();
    }
  },
  async getOrdersHistoryDecodedSSN({ commit }, { pharmacyId, orderId }) {
    try {
      const decodedSSN: DecodedSSN | undefined =
        await getOrdersHistoryDecodedSSN(pharmacyId, orderId);

      commit(OrderPaymentMutations.get_payments_history_decoded_ssn, {
        decodedSSN
      });
    } catch (error: unknown) {
      cleanLocalStorage();
    }
  },
  async getConfirmContent(_, { pharmacyId, orderId }) {
    try {
      await getConfirmContent(pharmacyId, orderId);
    } catch (error: unknown) {
      cleanLocalStorage();
    }
  },
  async getViewOrderById({ commit }, { pharmacyId, orderId }) {
    try {
      const viewOrder = await getViewOrderById(pharmacyId, orderId);

      commit(OrderPaymentMutations.get_view_payment, {
        viewOrder
      });
    } catch (error: unknown) {
      cleanLocalStorage();
    }
  },
  async resendPaymentNotification(_, data) {
    try {
      await resendPaymentNotification(data);
    } catch (error: unknown) {
      cleanLocalStorage();
    }
  },
  async cancelPaymentRequest(_, { orderId }) {
    try {
      await cancelPaymentRequest(orderId);
    } catch (error: unknown) {
      cleanLocalStorage();
    }
  },
  async addComment(_, { data, orderId }) {
    try {
      await addComment(data, orderId);
    } catch (error: unknown) {
      cleanLocalStorage();
    }
  }
};
